
import Modal from 'antd/lib/modal/Modal'
import { ColumnsType } from 'antd/lib/table'

import { Table } from 'components'

import React, { useMemo } from 'react'
import { IImportTypes } from '../../importInterfaces'

const TYPE_MAP: Record<IImportTypes, string> = {
  [IImportTypes.notaryFees]: 'custas_cartorarias',
  [IImportTypes.outstandingBalance]: 'modulo_saldo_devedor'
}

const TYPE_SPECIFIC_DATA: Record<IImportTypes, { subtitle: string; example: string }[]> = {
  [IImportTypes.notaryFees]: [
    { subtitle: 'Campo "Estado" deve ser sempre a sigla em letras maiúsculas', example: 'SP' },
    { subtitle: 'Campo "De" deve ser um valor numérico', example: '102780,00' },
    { subtitle: 'Campo "Até" deve ser um valor numérico', example: '34260,01' },
    { subtitle: 'Campo "Valor do custo" deve ser um valor numérico', example: '1328,2' },
    {
      subtitle: 'Não deve haver lacunas entre os valores numéricos nos campos referentes ao mesmo estado',
      example:
        'Se o campo Até da linha 15 for 3000, o campo De da linha 16 deve ser 3000,01 (desde que sejam referentes ao mesmo estado)'
    }
  ],
  [IImportTypes.outstandingBalance]: [
    { subtitle: 'Campo “CPF do Principal” deve ser um valor numérico', example: '44986343962' },
    { subtitle: 'Campo "Total a Pagar" deve ser um valor numérico', example: '102780,00' },
    { subtitle: 'Campo "Contrato Correlacional" deve ser um texto', example: '00001472EGI' },
    { subtitle: 'Campo "Prazo Remanescente em Parcelas" deve ser um valor numérico (em meses)', example: '73' },
    { subtitle: 'Campo "Num. Parc. em Atraso" deve ser um valor numérico', example: '1' },
    { subtitle: 'Campo "Total das Parc. em Atraso" deve ser um valor numérico', example: '34260,01' },
    { subtitle: 'Campo "Data da 1ª Parc. em atraso" deve estar no formato DD/mmm/YY', example: '02/ago/25' }
  ]
}

interface IImportHintModalProps {
  type: IImportTypes
  visible: boolean
  onCancel: () => void
}

function ImportHintModal ({ type, visible, onCancel }: IImportHintModalProps) {
  const selectedType = TYPE_MAP[type]
  const currentYear = new Date().getFullYear()

  const baseData = [
    {
      subtitle: `O nome do arquivo deve ser ${selectedType}_V + ano`,
      example: `${selectedType}_V${currentYear}.xlsx`
    },
    {
      subtitle: 'O formato do arquivo deve ser .xls ou .csv',
      example: `${selectedType}_V${currentYear}.csv`
    }
  ]

  const data = useMemo(() => {
    return [...baseData, ...(TYPE_SPECIFIC_DATA[type])]
  }, [type, selectedType])

  const columns: ColumnsType = useMemo(() => [
    { title: 'Legenda', dataIndex: 'subtitle', align: 'left' },
    { title: 'Exemplo', dataIndex: 'example', width: '400px' }
  ], [])

  return (
    <Modal
      width="1000px"
      title="Ver exemplo"
      visible={visible}
      destroyOnClose
      onCancel={onCancel}
      footer={null}
    >
      <h3 className='bold color-primary'>Exemplos</h3>
      <Table
        showPagination={false}
        canSearch={false}
        data={data}
        columns={columns}
        loading={false}
        className='proposal-configuration__table'
      />
    </Modal>
  )
}

export default ImportHintModal
